export default {

	computed: {

		loggedin: function() {

			return this.$store.getters['session/loggedin']


		},

		page: function() {

			return this.$store.getters['page']

		},

		response: function() {

			return this.$store.getters['response']

		},

		session: function() {

			return this.$store.getters['session']

		},

		data: function() {

			return this.$store.getters['data']

		},

		settings: function() {

			return this.$store.getters['settings']

        },
        
        isSessionCustomer: function() {

            return this.session.type === this.$constants.context.customer

        },
        
        isSessionBusiness: function() {

            return this.session.type === this.$constants.context.business

        },

		isContextCustomer: function() {

			return this.context === this.$constants.context.customer

		},

		isContextBusiness: function() {

			return this.context === this.$constants.context.business

		},

		context: function() {

			return (this.loggedin) ? this.$store.getters['session/type'] : this.$route.meta.context || this.$constants.context.any

		}

	}

}